import React from "react";
import { Avatar } from "../helper";

export default function ChallanAvatar({ username, radius }) {
  function stringToColor(string) {
    let hash = 0;
    let i;

    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
  }

  function stringAvatar(name, radius) {
    return {
      sx: {
        bgcolor: stringToColor(name),
        width: radius,
        height: radius,
      },
      children: name ? `${name[0]}` : "",
    };
  }

  return <Avatar {...stringAvatar(username, radius)} />;
}

ChallanAvatar.defaultProps = {
  radius: 40,
};
